<template>
  <div class="PublicityDetail8">
    <h3>7.8全国保险公众宣传日丨爱和责任 保险让生活更美好</h3>
    <img :src="require('../images/ic_publicity_detail8_1.jpg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail8_2.jpg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail8_3.jpg')"/>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail8'
};
</script>

<style scoped lang="less">
.PublicityDetail8 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  div {
    text-align: left;
  }

  img {
    width: 100%;
    margin-top: 30px;
    align-self: center;
  }
}
</style>
